import React from 'react';
import { useEnvironmentData } from 'hooks';

export default Component => props => {
    const data = useEnvironmentData();
    return (
        <Component
            {...props}
            env={data.env}
            platform={data.platform}
            cdn={data.cdn}
        />
    );
};
